import React from 'react'
import WebinarsLearningCenterCarousel from '@sial/aem-cms-components/dist/WebinarsLearningCenter/WebinarsLearningCenterCarousel'
import { useWebinarsLearningCenterQuery } from '@src/queries/WebinarsLearningCenterQuery.generated'
import { useUserSession } from '@src/utils/useUserSession'
import { useIntl } from 'react-intl'
import { useRouter } from '@src/routes'

const WebinarsLearningCenterAdapter: React.FC = () => {
  const { userSession } = useUserSession()
  const { country, language } = userSession
  const intl = useIntl()
  const router = useRouter()
  const session = intl.formatMessage({
    id: 'WEBINAR_SESSION_LABEL',
    defaultMessage: 'Session',
  })
  const presented = intl.formatMessage({
    id: 'WEBINAR_PRESENTED_LABEL',
    defaultMessage: 'Presented',
  })
  const languageLabel = intl.formatMessage({
    id: 'LANGUAGE',
    defaultMessage: 'Language',
  })
  const duration = intl.formatMessage({
    id: 'WEBINAR_DURATION_LABEL',
    defaultMessage: 'Duration',
  })
  const learnMore = intl.formatMessage({
    id: 'LEARN_MORE',
    defaultMessage: 'Learn More',
  })

  const translations = {
    session,
    presented,
    languageLabel,
    duration,
    learnMore,
  }

  const { data, error } = useWebinarsLearningCenterQuery({
    variables: {
      path: `/${country}/${language}/collections/webinars`,
    },
  })
  return (
    <WebinarsLearningCenterCarousel
      fetchedWebinars={data?.getWebinarsLearningCenter}
      translations={translations}
      error={error?.message}
      urlPath={router.asPath}
    />
  )
}

export default WebinarsLearningCenterAdapter
